import {ChartData} from "../chart-data";
import {BGChartType} from "../b-g-chart-type";
import {CodeNameSummaryChart} from "../../../stocks/models/code-name";

export class ChartGetDataModel {
    constructor(
        public readonly GUID: string,
        public readonly sharedGUID: string,
        public readonly type: BGChartType,
        public readonly typeCluster: BGChartType,
        public itemId: number | number[],
        public startDate: string,
        public endDate: string
    ){}
}

export class ChartSetDataModel {
    constructor(
        public GUID: string,
        public type: BGChartType,
        public data: ChartData,
        public summaryData: {codes: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number}
    ){}
}

export class GUIDChartsDataModel {
    constructor(){}

    public main: ChartGetDataModel[];
    public info: ChartGetDataModel[];
}

export class GUIDChartDataModel {
    constructor(
        public GUID: string,
        public itemId: number,
    ){}
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/chart-exchange.ts